import React from 'react';
import { ScreenShareOff, X } from 'lucide-react';

interface ScreenShareDropdownProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  position?: { right?: string | number; bottom?: string | number; left?: string | number; };
} 

/**
 * A dropdown menu for screen sharing options
 */
const ScreenShareDropdown: React.FC<ScreenShareDropdownProps> = ({
  isOpen,
  onClose,
  onConfirm,
  position = { bottom: '100%', right: 0 }
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="absolute z-50 w-64 bg-surface-light dark:bg-surface-dark rounded-lg border border-border-light dark:border-border-dark shadow-lg overflow-hidden" 
      style={{
        bottom: position.bottom,
        right: position.right,
        left: position.left,
        marginBottom: typeof position.bottom === 'string' ? '20px' : undefined
      }}
    >
      <div className="p-4">
        <div className="flex justify-between items-center mb-3">
          <h4 className="text-base font-semibold text-text-primary-light dark:text-text-primary-dark">Screen Sharing</h4>
          <button 
            onClick={onClose}
            className="p-1 rounded-full hover:bg-background-light/20 dark:hover:bg-background-dark/20"
          >
            <X className="w-4 h-4 text-text-secondary-light dark:text-text-secondary-dark" />
          </button>
        </div>
        
        <div className="py-1">
          <button
            onClick={onConfirm}
            className="flex items-center w-full rounded-md px-3 py-2 font-medium text-left text-sm text-text-primary-light dark:text-text-primary-dark hover:bg-background-light dark:hover:bg-background-dark"
          >
            <ScreenShareOff className="w-4 h-4 mr-3 text-text-secondary-light dark:text-text-secondary-dark" />
            Stop screen sharing
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScreenShareDropdown; 